module.exports = __webpack_public_path__ + "img/cpolic2.cb7ee097.png";